<!-- Button Square Template - Following Figma Design -->
<button
  type="button"
  [class]="containerClasses()"
  [disabled]="disabled || comingSoon"
  [attr.aria-label]="ariaLabel || title"
  [attr.aria-pressed]="state === 'selected'"
  (click)="onButtonClick()"
  role="button"
  tabindex="0"
  class="relative"
>
  <!-- Icon Section -->
  <div [class]="iconWrapperClasses()">
    <!-- SVG Icon -->
    <app-svg-icon 
      *ngIf="!!icon && !iconUrl"
      [iconName]="icon" 
      [size]="64"
      [class]="iconClasses()"
      aria-hidden="true"
    ></app-svg-icon>
    
    <!-- Image Icon -->
    <img
      *ngIf="iconUrl"
      [src]="iconUrl"
      [alt]="title"
      class="w-16 h-16 object-contain"
      aria-hidden="true"
    />
  </div>
  
  <!-- Title Section -->
  <span [class]="titleClasses()" class="flex items-center justify-center w-full h-[38px]" >
    {{ title }}
  </span>
  
  <!-- Coming Soon Badge - Positioned at bottom over icon -->
  <div *ngIf="comingSoon" [class]="comingSoonBadgeClasses()">
    Muy Pronto
  </div>
  
  <!-- New Badge with PillSoon Component -->
  <div *ngIf="propNew && !comingSoon" class="absolute -top-2 left-1/2 -translate-x-1/2 z-10">
    <ds-pill-soon 
      [textValue]="'Nuevo'"
      [animationValue]="'swing'"
      [backgroundColorValue]="'bg-cantera-red-stepper'"
      [textColorValue]="'text-white'"
      [sizeValue]="'medium'">
    </ds-pill-soon>
  </div>
</button>